import React from "react";
import Header from "./Header";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  background: {
    minHeight: "100vh",
    width: "100%",
    backgroundColor: theme.palette.background.default,
  },
  contentWrapper: {
    padding: theme.spacing(3),
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(4),
    },
  },
}));

export default function AppContainer({ children }) {
  const classes = useStyles();

  return (
    <div className={classes.background}>
      <Header />
      <div className={classes.contentWrapper}>{children}</div>
    </div>
  );
}
